module.exports = __webpack_public_path__ + "static/media/gonzalo_montiel.0d2b3f28.jpg";